module.exports = __webpack_public_path__ + "img/estacionamiento-bicicleta.7e2b82fc.svg";